/* eslint-disable max-len */
import { createSvgIcon } from "../../utils";

// SVG - 32 width, 32 height

const SharePinterest = createSvgIcon(
    <path
        d="M16.013 0C7.17 0 0 7.158 0 15.987c0 6.776 4.217 12.566 10.175 14.895-.145-1.264-.264-3.21.052-4.593.29-1.25 1.872-7.947 1.872-7.947s-.475-.96-.475-2.368c0-2.224 1.292-3.882 2.9-3.882 1.37 0 2.03 1.026 2.03 2.25 0 1.368-.87 3.421-1.332 5.33-.382 1.591.804 2.894 2.373 2.894 2.847 0 5.034-3 5.034-7.316 0-3.829-2.754-6.5-6.695-6.5-4.56 0-7.236 3.408-7.236 6.934 0 1.369.528 2.842 1.187 3.645a.475.475 0 01.105.46c-.119.5-.395 1.593-.448 1.816-.066.29-.237.355-.54.21-2.004-.933-3.256-3.841-3.256-6.197 0-5.04 3.664-9.67 10.584-9.67 5.548 0 9.87 3.947 9.87 9.236 0 5.513-3.479 9.948-8.302 9.948-1.621 0-3.15-.843-3.664-1.843l-1.002 3.803c-.356 1.395-1.33 3.132-1.99 4.198 1.503.46 3.084.71 4.745.71C24.83 32 32 24.842 32 16.013 32.026 7.158 24.857 0 16.013 0z"
        fill="#E60023"
    />,
    "SharePinterest",
);

export default SharePinterest;
